import {
  ButtonStyleDefinition,
  FormButtonElement,
  SignupForm,
  styleSheet,
} from "@redotech/redo-model/signup-form";
import { memo } from "react";
import { Button } from "../../button";
import { FormElementProps } from "./index";

export const FormButton = memo(function FormButton({
  form,
  element,
  ...props
}: FormElementProps<FormButtonElement>) {
  const style = GetButtonStyle(form, element);
  return (
    <Button
      pending={props.submitting}
      style={style}
      tooltip={undefined}
      type="submit"
    >
      {element.text}
    </Button>
  );
});

function GetButtonStyle(form: SignupForm, element: FormButtonElement) {
  const buttonStyleOverrides = form.theme.overrides.buttons.enabled
    ? element.style === "primary"
      ? ButtonStyleToCss(form.theme.overrides.buttons.primary)
      : ButtonStyleToCss(form.theme.overrides.buttons.secondary)
    : {};
  const buttonStyleDefaults =
    element.style === "primary"
      ? ButtonStyleToCss(styleSheet.buttons.primary)
      : ButtonStyleToCss(styleSheet.buttons.secondary);
  const buttonStyles = {
    ...buttonStyleDefaults,
    ...buttonStyleOverrides,
  };
  return buttonStyles;
}

function ButtonStyleToCss(style: ButtonStyleDefinition): React.CSSProperties {
  return {
    backgroundColor: style.backgroundColor,
    color: style.textColor,
    border: style.border.stroke.enabled
      ? `${style.border.stroke.weightPx}px solid ${style.border.stroke.color}`
      : "none",
    borderRadius: `${style.border.cornerRadiusPx}px`,
    width: "100%",
  };
}
